import { Text, Flex, Box } from '@chakra-ui/react';
import { FlagIcon } from '../../../FlagIcon';
import { PHONE_PREFIX } from './helpers';

interface ICountryBtnEl {
  name: string | undefined;
  code: string | undefined;
}

export const CountryBtnEl = (props: ICountryBtnEl) => {
  const { name, code } = props || {};
  
  return (
    <Flex alignItems='center'>
      <Box display={['none', 'initial']}>
        <FlagIcon countryCode={name} />
      </Box>

      <Text textTransform='uppercase' pl={[0, 2]} pr={2}>
        {name}
      </Text>
      <Text color='cyan.500'>{`${PHONE_PREFIX || ''}${code || ''}`}</Text>
    </Flex>
  );
};
